<div class="countdown-timer" *ngIf="show">
  <div class="days" *ngIf="days >= 0"><strong>{{days}}</strong><span i18n="timer | days">Days</span></div>
  <div class="hours" *ngIf="hours >= 0"><strong>{{hours}}</strong><span i18n="timer | hours">Hours</span></div>
  <i class="line"></i>
  <div class="minutes" *ngIf="minutes >= 0"><strong>{{minutes}}</strong><span i18n="timer | minutes">Minutes</span></div>
  <div class="seconds" *ngIf="seconds >= 0"><strong>{{seconds}}</strong><span i18n="timer | seconds">Seconds</span></div>
</div>
